import Layout from "@/layout/layout";
import "@/styles/globals.css";
import "@/styles/index.css";
import "@/styles/media-query.css";
import "@/styles/hashnode.css"
import '../styles/scss/style.scss';
import 'react-loading-skeleton/dist/skeleton.css'

// Supports weights 200-800
import '@fontsource-variable/manrope';
import { I18nextProvider } from 'react-i18next';
import i18n from '../i18n';
import { wrapper } from "@/redux/store";
import { AnimatePresence, motion } from "framer-motion";
import Head from "next/head";
import { Button } from "rizzui";
import CookieConsent from "@/components/cookies/cookieConsent";

function App({ Component, pageProps, router }) {
  const spring = {
    type: "spring",
    damping: 20,
    stiffness: 100,
    when: "afterChildren"
  };


  function ChatScript() {
    return {
      __html: `
      (function(d,t) {
    var BASE_URL="https://chatwoot.ldb.co.in";
    var g=d.createElement(t),s=d.getElementsByTagName(t)[0];
    g.src=BASE_URL+"/packs/js/sdk.js";
    g.defer = true;
    g.async = true;
    s.parentNode.insertBefore(g,s);
    g.onload=function(){
      window.chatwootSDK.run({
        websiteToken: 'W9pteq6PcujBUzTPfPZd17Y6',
        baseUrl: BASE_URL
      })
    }
  })(document,"script");
      `
    }
  }

  return (
    <AnimatePresence>
      <motion.div
        transition={spring}
        key={router.pathname}
        initial={{ x: 300, opacity: 0 }}
        animate={{ x: 0, opacity: 1 }}
        exit={{ x: -300, opacity: 0 }}
        id="page-transition-container">
        <I18nextProvider i18n={i18n}>
          <Head>
            <script
              strategy="lazyOnload"
              dangerouslySetInnerHTML={ChatScript()}
              key="chat-script"
            />
          </Head>
          <Layout>
            <Component {...pageProps} />
            <CookieConsent />
          </Layout>
        </I18nextProvider>
      </motion.div>
    </AnimatePresence>
  );
}

export default wrapper.withRedux(App)
